import React from 'react';

export type Experiment<T> = {
  id: string;
  baseline: T;
  variants: { [experimentId: string]: T };
};
export type ExperimentValue<T> = {
  showEditor?: boolean;
  sessionId?: string;
  selectedVariants?: {
    [key: string]: { variantIndex: number; selectedVariant: string };
  };
  experiments?: Array<Experiment<T>>;
  registerExperiment?: (experiment: Experiment<T>) => void;
  selectedVariant?: (experiment: Experiment<T>, variant: string) => void;
};

const ExperimentContext = React.createContext<ExperimentValue<any>>({});
ExperimentContext.displayName = 'ExperimentContext';

export default ExperimentContext;
